/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */

import { TableInfo } from "../types.ds";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const addNewGameTable = async (id: string) => {
    const formData = new FormData();
    formData.append('table_id', id);

    try {
        // Send the POST request using fetch
        const response = await fetch(`${API_ENDPOINT}/post/create_table`, {
            method: 'POST',
            body: formData,
        });

        // Check if the request was successful
        const result = await response.json();
        if (response.ok) {
            const res: TableInfo = result;
            return res;
        } else {
            const res: TableInfo = result;
            return res;
        }
    } catch (error) {
        console.error('There was an error!', error);
        alert('Error updating profile.');
    }
};